// src/components/brandCustomization/TicketCustomization/TicketLayoutOptions.jsx
import React from 'react';
import { ticketLayoutOptions } from '../../../utils/brandCustomization';

/**
 * TicketLayoutOptions - Opciones de diseño para la tarjeta según el layout seleccionado
 */
const TicketLayoutOptions = ({
    layout,
    layoutOptions = {},
    onChange
}) => {
    // Filtrar opciones según el layout actual
    const availableOptions = ticketLayoutOptions.filter(option => {
        if (!option.layouts) return true;
        return option.layouts.includes(layout);
    });

    const handleOptionChange = (key, value) => {
        onChange(`layoutOptions.${key}`, value);
    };

    return (
        <div className="pt-4 border-t border-purple-200">
            <h5 className="text-sm font-semibold text-gray-900 mb-3">Opciones de Diseño</h5>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {availableOptions.map((option) => (
                    <div key={option.key} className="flex items-center gap-2 p-3 bg-white rounded-lg border border-gray-200">
                        <input
                            type="checkbox"
                            checked={layoutOptions[option.key] !== false}
                            onChange={(e) => handleOptionChange(option.key, e.target.checked)}
                            className="w-4 h-4 text-purple-600 border-gray-300 rounded focus:ring-purple-500"
                        />
                        <label className="text-sm text-gray-700 cursor-pointer">
                            {option.label}
                        </label>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default TicketLayoutOptions;

